module.exports = __webpack_public_path__ + "static/media/12.385ea39d.jpg";